module.exports = __webpack_public_path__ + "img/press-photo.a1479152.jpg";